<template>
  <div v-if="article!=null" style="padding: 30px;">
    <div v-html="article.content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      article: null
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getInfo(this.$route.query.id)
    } else if (this.$route.query.name) {
      this.searchInfo(this.$route.query.name)
    } else if (this.$route.query.code) {
      this.searchInfo(this.$route.query.code)
    }
  },
  methods: {
    getInfo(id) {
      this.$api.article.info(id).then(response => {
        this.article = response
        this.setTitle()
      })
    },
    searchInfo(code) {
      this.$api.article.search(code).then(response => {
        this.article = response
        this.setTitle()
      })
    },
    setTitle() {
      if (this.article) {
        document.title = this.article.title
      }
    }
  }
}
</script>
